"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { captureSocialAcquisition } from "@/lib/social-acquisition";
export function SocialAcquisitionCapture() {
  const pathname = usePathname();
  useEffect(() => { captureSocialAcquisition(); }, [pathname]);
  return null;
}
